/** Shared customers list page size (POS `start`/`size`). Keep free of store imports. */
export const CUSTOMERS_PAGE_SIZE = 200;
